import * as React from 'react';
import { SVGProps } from 'react';
export const CommentsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M13.003 0A13 13 0 0 0 1.525 19.11L.107 23.366a2 2 0 0 0 2.53 2.53l4.256-1.419A13 13 0 1 0 13.003 0Zm-5.5 14.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm5.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm5.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    />
  </svg>
);
